export const RM_PREFIX = 'RM';
export const RM_GROUP_CARD_ID = -1;
export const RM_GROUP_IMAGE = '/assets/region-metropolitana.webp';
// Reachable via direct URL only: Salamanca (staging), Faena Mantos de Oro (prod)
export const SALFA_HIDDEN_LOCATION_IDS = [10050, 486357];
